import Echo from "laravel-echo";
import Pusher from "pusher-js";
import Cookies from "js-cookie";

window.Pusher = Pusher;

const env =
  typeof import.meta !== "undefined" && import.meta.env
    ? import.meta.env
    : process.env;

const API_BASE = (env.VITE_API_URL || env.VUE_APP_API_URL || "http://localhost:8000").replace(/\/$/, "");
const KEY = env.VITE_REVERB_APP_KEY || env.VUE_APP_REVERB_APP_KEY;

const WS_HOST = env.VITE_REVERB_HOST || env.VUE_APP_REVERB_HOST || "localhost";
const WS_PORT = Number(env.VITE_REVERB_PORT || env.VUE_APP_REVERB_PORT || 8081);
const SCHEME = String(env.VITE_REVERB_SCHEME || env.VUE_APP_REVERB_SCHEME || "http").toLowerCase();
const FORCE_TLS = SCHEME === "https";

const getToken = () => localStorage.getItem("token") || Cookies.get("token") || "";

export function initEcho() {
  if (!KEY) return null;

  const token = getToken();

  if (window.Echo) {
    try { window.Echo.disconnect(); } catch {
      // ignore
    }
    window.Echo = null;
  }

  window.Echo = new Echo({
    broadcaster: "reverb",
    key: KEY,
    wsHost: WS_HOST,
    wsPort: WS_PORT,
    wssPort: WS_PORT,
    forceTLS: FORCE_TLS,
    enabledTransports: ["ws", "wss"],
    authEndpoint: `${API_BASE}/api/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      },
    },
  });

  return window.Echo;
}

export function updateEchoAuth() {
  if (!window.Echo) return initEcho();
  const token = getToken();
  try {
    window.Echo.connector.options.auth.headers.Authorization = token ? `Bearer ${token}` : "";
  } catch {
    // ignore
  }
  return window.Echo;
}
